var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"download":_vm.download,"href":_vm.href,"target":"_blank"}})}
var staticRenderFns = []

export { render, staticRenderFns }